import { createContext, useContext, type ReactNode } from 'react';

import { useTema } from './tema';

type TemaCtx = ReturnType<typeof useTema>;
const Ctx = createContext<TemaCtx | null>(null);

/** Un solo estado de tema para toda la app (selector, toasts, gráficas). */
export function TemaProvider({ children }: { children: ReactNode }) {
  return <Ctx value={useTema()}>{children}</Ctx>;
}

export function useTemaActual(): TemaCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useTemaActual fuera de <TemaProvider>');
  return ctx;
}
